import React, { useState } from 'react';
import { auth } from '../firebase/config';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { FcGoogle } from 'react-icons/fc';
import { saveUserToDb } from '../services/userService';

export function LoginDialog({ open, onOpenChange }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleGoogleSignIn = async () => {
        try {
            setIsLoading(true);
            setError(null);

            // Debug log to check if Firebase config is loaded
            console.log('Firebase Config:', {
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
                authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
                // ... log other configs but mask sensitive values
            });

            const provider = new GoogleAuthProvider();
            provider.addScope('profile');
            provider.addScope('email');

            const result = await signInWithPopup(auth, provider);

            try {
                const isNewUser = await saveUserToDb(result.user);
                onOpenChange(false);

                // Redirect based on whether profile is complete
                if (isNewUser) {
                    navigate('/complete-profile');
                } else {
                    navigate('/search');
                }
            } catch (dbError) {
                console.error("Error saving user to database:", dbError);
            }

            // console.log("Auth Token:", token);
            console.log("Signed in user:", result.user);
            console.log("Details:", result.user.toJSON());
        } catch (error) {
            console.error("Error signing in with Google:", error);
            setError(`Failed to sign in: ${error.message}`);
            // Add more detailed error logging
            console.error("Full error object:", {
                code: error.code,
                message: error.message,
                stack: error.stack
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px] bg-black/90 border-gray-800">
                <DialogHeader>
                    <DialogTitle className="text-white">Welcome to Papers with Graph</DialogTitle>
                    <DialogDescription className="text-gray-400">
                        Sign in to start exploring research papers
                    </DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-4 py-4">
                    <button
                        onClick={handleGoogleSignIn}
                        disabled={isLoading}
                        className="flex items-center justify-center gap-3 w-full px-4 py-3 text-white bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <FcGoogle className="w-5 h-5" />
                        {isLoading ? 'Signing in...' : 'Continue with Google'}
                    </button>
                    {error && (
                        <p className="text-red-500 text-sm text-center">{error}</p>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default LoginDialog;